import React from "react";
import { useContext } from "../../../context";
import { showFormattedDate } from "../../../../../../../../../Utils";

export function DateTime() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>{"Date & Time:"}</label>
      <span>{showFormattedDate(appointment.date, true)}</span>
    </div>
  );
}
